import { render, staticRenderFns } from "./CardRegistrosNoValidos.vue?vue&type=template&id=da2340ac&scoped=true"
import script from "./CardRegistrosNoValidos.vue?vue&type=script&lang=js"
export * from "./CardRegistrosNoValidos.vue?vue&type=script&lang=js"
import style0 from "./CardRegistrosNoValidos.vue?vue&type=style&index=0&id=da2340ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2340ac",
  null
  
)

export default component.exports